import { FC } from 'react'
import { Button, ButtonLink } from '@branch-messenger/willow-ui'

import { FlowCardButtonLinkProps, FlowCardButtonProps } from './types'

export const FlowCardButton: FC<FlowCardButtonProps> = props => (
  <Button {...props} size="lg" />
)

export const FlowCardButtonLink: FC<FlowCardButtonLinkProps> = ({
  ref,
  ...props
}) => <ButtonLink ref={ref} {...props} size="lg" />
